export const retryWithDelay = async (
  fn,
  maxRetries = 10,
  delay = 1000,
  onRetry = null
) => {
  let lastError;

  for (let i = 0; i < maxRetries; i++) {
    try {
      const result = await fn();
      return result;
    } catch (error) {
      lastError = error;

      if (i < maxRetries - 1) {
        if (onRetry) {
          onRetry(i + 1, error);
        }

        await new Promise((resolve) =>
          setTimeout(resolve, delay * Math.pow(2, i))
        );
      }
    }
  }

  throw lastError;
};

export const retryImmediate = async (fn, maxRetries = 10, onRetry = null) => {
  let lastError;

  for (let i = 0; i < maxRetries; i++) {
    try {
      const result = await fn();
      if (result?.status === 200) {
        return result;
      }
      throw new Error(`Unexpected status: ${result?.status}`);
    } catch (error) {
      lastError = error;

      if (i < maxRetries - 1 && onRetry) {
        onRetry(i + 1, error);
      }
    }
  }

  throw lastError;
};
